import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  HOME_PAGE_SETTING,
  RAISE_QUERY,
  SETTING,
  PRIVACY_DATA,
  CANCELL_POLICY,
  ABOUT_US,
  TERMS_DATA,
  GOLFCLIX_COUNTRY,
} from "./types";
import {
  getHomePageSettingApi,
  queryApi,
  getSettingApi,
  getPrivacyDataApi,
  getCancellationPolicyApi,
  getAbout_US_Api,
  getTermsApi,
} from "@services/apis";
import { goflclixCountryApi } from "../../golfClixServices/auth";

export const getHomePageSetting = createAsyncThunk(
  HOME_PAGE_SETTING,
  async (data) => {
    try {
      const response = await getHomePageSettingApi(data);
      return response;
    } catch (err) {
      return err;
    }
  }
);
export const getSetting = createAsyncThunk(SETTING, async (data) => {
  try {
    const response = await getSettingApi();
    return response;
  } catch (err) {
    return err;
  }
});

export const getPrivacyData = createAsyncThunk(PRIVACY_DATA, async (data) => {
  try {
    const response = await getPrivacyDataApi(data);
    return response;
  } catch (err) {
    return err;
  }
});

export const getCancellationPolicy = createAsyncThunk(
  CANCELL_POLICY,
  async (data) => {
    try {
      const response = await getCancellationPolicyApi(data);
      return response;
    } catch (err) {
      return err;
    }
  }
);

export const getAbout_US = createAsyncThunk(ABOUT_US, async (data) => {
  try {
    const response = await getAbout_US_Api(data);
    return response;
  } catch (err) {
    return err;
  }
});

export const getTerms = createAsyncThunk(TERMS_DATA, async (data) => {
  try {
    const response = await getTermsApi(data);
    return response;
  } catch (err) {
    return err;
  }
});

export const raiseQuery = createAsyncThunk(RAISE_QUERY, async (data) => {
  try {
    const response = await queryApi(data);
    return response;
  } catch (err) {
    return err;
  }
});

export const getGolfclixCountry = createAsyncThunk(
  GOLFCLIX_COUNTRY,
  async (data) => {
    try {
      const response = await goflclixCountryApi(data);
      return response;
    } catch (err) {
      return err;
    }
  }
);
